var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("系统配置")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("配置列表"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "属性名" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入属性名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-table",
              {
                ref: "scrollTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "id", label: "编号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "sort", label: "排序", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "propName", label: "属性名", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "propValue", label: "值", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "propDesc",
                    label: "属性描述",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n                编辑\n              ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticStyle: { margin: "0 auto" },
              attrs: {
                "label-position": "right",
                model: _vm.ruleForm1,
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "属性", prop: "key" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { placeholder: "请输入属性名称" },
                    model: {
                      value: _vm.ruleForm1.key,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "key", $$v)
                      },
                      expression: "ruleForm1.key",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "值", prop: "val" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { placeholder: "请输入属性值" },
                    model: {
                      value: _vm.ruleForm1.val,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "val", $$v)
                      },
                      expression: "ruleForm1.val",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "属性描述", prop: "memo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { placeholder: "请输入属性描述" },
                    model: {
                      value: _vm.ruleForm1.memo,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "memo", $$v)
                      },
                      expression: "ruleForm1.memo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "memo" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { placeholder: "请输入排序" },
                    model: {
                      value: _vm.ruleForm1.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm1, "sort", $$v)
                      },
                      expression: "ruleForm1.sort",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm1("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }